import { useContext } from "react";
import { LocalizedPricesContext, type LocalizedPrices } from "../contexts/LocalizedPricesContext";

export function useLocalizedPrices(): LocalizedPrices {
  const value = useContext(LocalizedPricesContext);
  if (!value) throw new Error("useLocalizedPrices debe usarse dentro de LocalizedPricesProvider");
  return value;
}
